module.exports = "<router-outlet>\n</router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 167
// module chunks = 1